module.exports = __webpack_public_path__ + "img/designs-1023.2beb77d.png";